import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

const DateSeparator = ({ label }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 1.5,
        width: "100%",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          px: 1.5,
          py: 0.35,
          borderRadius: 999,
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.grey[800]
              : theme.palette.grey[200],
          color: theme.palette.text.secondary,
          fontWeight: 600,
          fontSize: "0.75rem",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default DateSeparator;
